import type { Person } from '../../eventsApi/persons/person'
import type { PaymentMethod } from '../../posApi/payment-methods/payment-methods'
import type { Account } from '../accounts/account'
import type { Category } from '../categories/category'
import type { EntryTypeEnum } from './entry.enum'

export class Entry {
    entryId: string
    companyId: string
    createdAt: Date
    updatedAt: Date
    paymentAt: Date
    reference: Date
    description?: string
    status: number
    categoryId: string
    accountId: string
    personId: string
    value: number
    type: EntryTypeEnum
    source: string // manual / import
    person?: Person
    category?: Category
    account: Account
    externalId?: string
    classificationId?: string
    cashierId?: string
    accrualMonth?: number
    accrualYear?: number
    groupId?: string
    invoiceId?: string
    paymentMethodId?: string
    paymentMethod?: PaymentMethod
}
